import { MarkerClustererProps } from '@react-google-maps/api'

export const API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!

export const clusterMarkerStyles: NonNullable<
  MarkerClustererProps['options']
>['styles'] = Array.from({ length: 5 }).map((_, i) => ({
  url: `/assets/markers/cluster_m${i + 1}.svg`,
  width: 30,
  height: 43,
  fontFamily: 'Noto Sans JP,sans-serif',
  textColor: 'white',
}))

export const mapStyles = [
  {
    featureType: 'poi.attraction',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#6ad4e2',
      },
    ],
  },
  {
    featureType: 'poi.business',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#a8caff',
      },
    ],
  },
  {
    featureType: 'poi.government',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#aabcc5',
      },
    ],
  },
  {
    featureType: 'poi.medical',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#fb9489',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#82d998',
      },
    ],
  },
  {
    featureType: 'poi.place_of_worship',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#a9bcc6',
      },
    ],
  },
  {
    featureType: 'poi.school',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#a9bcc6',
      },
    ],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#60d282',
      },
    ],
  },
]

export const mapOptions: google.maps.MapOptions = {
  // Disable default UI
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false,
  zoomControl: false,
  disableDoubleClickZoom: true,
  clickableIcons: false,
  styles: mapStyles,
  // Zoom levels
  minZoom: 9,
  maxZoom: 20,
}

export const markerOptions: google.maps.MarkerOptions = {
  optimized: true,
}
